import { render, staticRenderFns } from "./MspTestAttivi.vue?vue&type=template&id=2ddeec6d"
import script from "./MspTestAttivi.vue?vue&type=script&lang=js"
export * from "./MspTestAttivi.vue?vue&type=script&lang=js"
import style0 from "./MspTestAttivi.vue?vue&type=style&index=0&id=2ddeec6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports